<template>
  <base-layout>
    <template #sidebar>
      <ui-settings-sidebar />
    </template>
    <template #breadcrumbs>
      <ui-breadcrumbs title="Справочники" />
    </template>
    <div class="bg-white shadow-sm p-3">
      <div class="mb-3">
        <ui-add-button :href="route('settings.dict_types.create')" />
      </div>

      <ul class="list-group">
        <li
          v-for="item in items"
          :key="item.id"
          class="list-group-item"
        >
          <div class="d-flex justify-content-between align-items-center">
            <Link :href="route('settings.dict_types.show', item.id)">
              [{{ item.name }}: {{ item.values.length }}] {{ item.title }}
            </Link>
            <el-button
              icon="el-icon-edit"
              @click="editClick(item)"
            >
              Изменить
            </el-button>
          </div>
        </li>
      </ul>
    </div>
  </base-layout>
</template>

<script>

import UiSettingsSidebar from '@Settings/Ui/UiSettingsSidebar';
import { Link } from '@inertiajs/inertia-vue3';
import BaseLayout from '@/Layouts/BaseLayout';
import UiBreadcrumbs from '@/components/Ui/UiBreadcrumbs';
import UiAddButton from '@/components/Ui/UiAddButton';

export default {
  name: 'Settings',
  components: {
    UiAddButton,
    UiSettingsSidebar,
    UiBreadcrumbs,
    BaseLayout,
    Link,
  },
  props: {
    items: { type: Array, required: true },
  },
  data() {
    return {};
  },
  methods: {
    editClick(item) {
      this.$inertia.visit(route('settings.dict_types.edit', item.id));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
